import { render, staticRenderFns } from "./hotNewsDetails.vue?vue&type=template&id=01e4473a"
import script from "./hotNewsDetails.vue?vue&type=script&lang=js"
export * from "./hotNewsDetails.vue?vue&type=script&lang=js"
import style0 from "./hotNewsDetails.vue?vue&type=style&index=0&id=01e4473a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports